import { render, staticRenderFns } from "./EditVenturaAdmin.vue?vue&type=template&id=1653f2f8&scoped=true&"
import script from "./EditVenturaAdmin.vue?vue&type=script&lang=js&"
export * from "./EditVenturaAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1653f2f8",
  null
  
)

export default component.exports